import isEqual from 'lodash/isEqual'

export const actual = (func) => {
  return (argFunc) => {
    return new Promise(async (resolve, reject) => {
      const args = argFunc()
      const result = await func(...args)
      if (isEqual(argFunc(), args)) {
        resolve(result)
      }
    })
  }
}

export const canvasToBlob = (canvas) => {
  return new Promise((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', 0.95)
  })
}

export const delay = (duration) => {
  return new Promise((resolve) => {
    setTimeout(resolve, duration)
  })
}
